<script>
export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
	name: 'match-detail-demo-tab-one',

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            tabOneData: {},
            locale: {}
        }
    },

    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
    },
}
</script>

<template>
    <div>
        <p>Tab One</p>
        <p>{{ tabOneData.label }}</p>
        <p>{{ locale.submit }}</p>
    </div>
</template>